export default function TransformDate(date) {
  const parsed = new Date(date);
  const year = parsed.getFullYear();
  const month = (parsed.getMonth() + 1).toString().padStart(2, "0");
  const day = parsed.getDate().toString().padStart(2, "0");
  return `${year}-${month}-${day}`;
}
